export function isFromMobileApp() {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || 'null');
    if (u && u.fromMobileApp) return true;
  } catch {
    /* ignore */
  }
  const params = new URLSearchParams(window.location.search);
  return params.get('fromMobileApp') === 'true';
}

export function postMobileBackOrRedirect(url) {
  if (isFromMobileApp()) {
    try {
      if (
        typeof window !== 'undefined' &&
        window.GameStatus &&
        typeof window.GameStatus.postMessage === 'function'
      ) {
        window.GameStatus.postMessage('navigate_back');
      } else {
        console.warn(
          '[mobileNavigate] window.GameStatus.postMessage not available; ignoring redirect because fromMobileApp=true'
        );
      }
    } catch (err) {
      console.warn('[mobileNavigate] postMessage failed:', err);
    }
    return;
  }
  if (url) window.location.href = url;
}
